import React from 'react';
import { Reveal } from '../common/Reveal';
import { TIMELINE } from '../../data/constants';

export function Timeline() {
  return (
    <section id="timeline" className="py-20 md:py-28 px-8 md:px-16 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-[600px] mb-16">
          <Reveal>
            <div className="text-[0.68rem] font-normal tracking-[0.35em] uppercase text-nestlent-green mb-3">Our Journey</div>
          </Reveal>
          <Reveal delay={100}>
            <h2 className="font-serif text-[clamp(2.2rem,4vw,3.4rem)] font-light leading-[1.12] text-nestlent-charcoal mb-6">
              Milestones & <em className="italic text-nestlent-green">Growth</em>
            </h2>
          </Reveal>
          <Reveal delay={180}>
            <div className="w-12 h-px bg-nestlent-green" />
          </Reveal>
        </div>

        <div className="relative pl-8 md:pl-12 before:content-[''] before:absolute before:left-0 before:top-0 before:bottom-0 before:w-px before:bg-nestlent-grey-light">
          {TIMELINE.map((item, i) => (
            <Reveal key={i} delay={i * 150} y={20}>
              <div className={`relative pb-12 mb-12 ${i < TIMELINE.length - 1 ? 'border-b border-nestlent-grey-light' : ''} group`}>
                {/* Dot */}
                <div className="absolute -left-8 md:-left-12 top-1 w-3 h-3 rounded-full bg-white border-2 border-nestlent-green transition-colors duration-300 -translate-x-1/2 group-hover:bg-nestlent-green" />
                {/* Year */}
                <div className="text-[0.7rem] tracking-[0.2em] uppercase text-nestlent-green mb-1.5">{item.year}</div>
                {/* Event */}
                <div className="font-serif text-[1.4rem] font-normal text-nestlent-charcoal mb-2.5">{item.event}</div>
                {/* Description */}
                <div className="text-[0.88rem] font-light text-nestlent-grey leading-[1.7]">{item.desc}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
